import { PropertyMetadata, VcfInfraData } from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';
export interface InitializeStepNetwork {
  type: Constants.INITIALIZE_STEP_NETWORK;
}

export interface InitializeStepNetworkSuccess {
  type: Constants.INITIALIZE_STEP_NETWORK_SUCCESS;
  payload: {
    properties?: PropertyMetadata[];
    vcfInfraData?: VcfInfraData;
  };
}

export interface InitializeStepNetworkFailed {
  type: Constants.INITIALIZE_STEP_NETWORK_FAILED;
}

export type StepNetworkAction =
  | InitializeStepNetwork
  | InitializeStepNetworkFailed
  | InitializeStepNetworkSuccess;

export const initializeStepNetwork = (): InitializeStepNetwork => ({
  type: Constants.INITIALIZE_STEP_NETWORK
});

export const initializeStepNetworkSuccess = (
  properties?: PropertyMetadata[],
  vcfInfraData?: VcfInfraData
): InitializeStepNetworkSuccess => ({
  payload: { properties, vcfInfraData },
  type: Constants.INITIALIZE_STEP_NETWORK_SUCCESS
});

export const initializeStepNetworkFailed = (): InitializeStepNetworkFailed => ({
  type: Constants.INITIALIZE_STEP_NETWORK_FAILED
});
